export const CatalogBanner = () => {}
